// extracted by mini-css-extract-plugin
export default {"card":"QY-z","carouselContainer":"RY-z","carouselContent":"SY-z"};